@if (allocations.length === 0) {
  <div class="text-center py-4">No allocations found.</div>
}

@for (allocation of allocations; track allocation.voucherAllocationId; let i = $index) {
  <div class="clickable col-6 mb-3" (click)="onViewAllocation(allocation.voucherAllocationId)">
    <cert-voucher-allocation-card [allocation]="allocation" [includeHoverEffects]="true" />
  </div>
}
